// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"326":"95a7dbb5","445":"61e68ac0","742":"77e3dcd4"}[chunkId] + ".css";
};